import CoppaEmailInput from './CoppaEmailInput'

export default CoppaEmailInput
